import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject, ReplaySubject } from "rxjs";
import { TenantIdentifierInfo, TenantInfoSource } from "../interfaces/tenant.interfaces";
import { share } from "rxjs/operators";

@Injectable()
export class TenantIdService {

    public tenantIdentifier: ReplaySubject<TenantIdentifierInfo> = new ReplaySubject<TenantIdentifierInfo>(1);

    constructor() {
    }

    public get tenantId(): Observable<TenantIdentifierInfo> {
        return this.tenantIdentifier
            .pipe(
                share()
            );
    }

    public setTenantId(tenantName: string, source: TenantInfoSource) {
        const tenantIdPath = source == 'path' ? '/t/' + tenantName : '';
        this.tenantIdentifier.next({ name: tenantName ?? '', source, path: tenantIdPath });
        this.tenantIdentifier.complete();
    }
}
